import { cardNotificationsActions } from "./cardNotifications-slice";
import { uiActions } from "./ui-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchCardData = (url_data, token) => {
	return async (dispatch) => {
		dispatch(uiActions.showLoadingSpinner(6));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const cardData = await fetchData();
			dispatch(cardNotificationsActions.updateCard(cardData));
			dispatch(uiActions.hideLoadingSpinner(6));
		} catch (error) {
			console.log(error);
		}
	};
};
